export const IMAGE_FAMILY = {
  general: 'general',
  ThreeD: 'ThreeD',
};

export const name = 'registerService';
export default function registerService($mdMedia) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const imageUrlBase = 'https://cdn.printos.com/images/signin';
  const imageSizes = {
    large: '1920x1080',
    medium: '1280x1024',
  };
  // List of images to use and how to position them for proper emphasis with smaller widths.
  const imagePositions = {
    [IMAGE_FAMILY.general]: {
      '1.jpg': 'center',
      '4.jpg': '30% center',
      '6.jpg': '35% center',
      '8.jpg': '10% center',
      '9.jpg': 'center',
      '10.jpg': '60% center',
      '13.jpg': '35% center',
      '14.jpg': 'center',
      '15.jpg': 'center',
      '16.jpg': 'center',
      '18.jpg': '75% center',
      '19.jpg': '70% center',
      '20.jpg': '30% center',
      '25.jpg': 'center',
      '27.jpg': '60% center',
      '29.jpg': '0 center',
      '31.jpg': 'center',
      '32.jpg': 'center',
      '33.jpg': 'center',
      '34.jpg': 'center',
      '35.jpg': 'center',
      '36.jpg': '15% center',
      '37.jpg': '30% center',
      '38.jpg': 'center',
      '39.jpg': 'center',
      '40.jpg': 'center',
      '41.jpg': 'center',
      '42.jpg': 'center',
      '43.jpg': 'center',
      '44.jpg': '65% center',
      '45.jpg': 'center',
      '46.jpg': 'center',
      '47.jpg': 'center',
      '48.jpg': '80% center',
      '49.jpg': '10% center',
      '50.jpg': 'center',
      '51.jpg': '25% center',
      '52.jpg': 'center',
      '53.jpg': '30% center',
      '54.jpg': 'center',
      '55.jpg': 'center',
    },
    [IMAGE_FAMILY.ThreeD]: {
      '68.jpg': '15% center',
    },
  };

  let selectedImages = {};

  let service = {
    getBackgroundImage,
    getPosition,
    unitTest: {
      setImageName(family, name) {
        selectedImages[family] = name;
      },
    }
  };

  activate();
  return service;

  ////////////////
  function activate() {
    for (let family in imagePositions) {
      selectedImages[family] = _.sample(Object.keys(imagePositions[family]));
    }
  }

  function getBackgroundImage(imageFamily = IMAGE_FAMILY.general) {
    let imageName = selectedImages[imageFamily];
    if (!imageName) {
      // fall back to general - preferable to a blank screen
      imageName = selectedImages[IMAGE_FAMILY.general];
    }

    let resolution = $mdMedia('gt-md') ? imageSizes.large : imageSizes.medium;
    return `${imageUrlBase}/${resolution}/${imageName}`;
  }

  function getPosition(imageFamily = IMAGE_FAMILY.general) {
    let imageName = selectedImages[imageFamily];
    let position;
    if (imageName) {
      position = imagePositions[imageFamily][imageName];
    } else {
      // fall back to general - preferable to a blank screen
      imageName = selectedImages[IMAGE_FAMILY.general];
      position = imagePositions[IMAGE_FAMILY.general][imageName];
    }

    return position;
  }
}



// WEBPACK FOOTER //
// ./components/start-background/register.service.js